import { useState } from "react";
import "./App.css";
import Input from "./components/UI/Input";
import { Todo } from "./model";
import TodoList from "./components/TodoList/TodoList";
import { DragDropContext, DropResult } from "react-beautiful-dnd";

const App: React.FC = () => {
    const [todo, setTodo] = useState<string>("");
    const [todos, setTodos] = useState<Todo[]>([]);
    const [completedTodos, setCompletedTodos] = useState<Todo[]>([]);

    const addTodos = (e: React.FormEvent) => {
        e.preventDefault();

        if (todo) {
            setTodos([
                ...todos,
                { id: Date.now(), title: todo, isDone: false }
            ]);
            setTodo("");
        }
    };

    const onDragEnd = (result: DropResult) => {
        const { source, destination } = result;

        if (!destination) {
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        let add,
            active = todos,
            complete = completedTodos;

        if (source.droppableId === "TodosList") {
            add = active[source.index];
            active.splice(source.index, 1);
        } else {
            add = complete[source.index];
            complete.splice(source.index, 1);
        }

        if (destination.droppableId === "TodosList") {
            active.splice(destination.index, 0, add);
        } else {
            complete.splice(destination.index, 0, add);
        }

        setCompletedTodos(complete);
        setTodos(active);
    };

    const toggleTodo = (id: number) => {
        const item = todos.find((todo) => todo.id === id);

        if (!item) {
            const item = completedTodos.find((todo) => todo.id === id);
            item && setTodos((todos) => [...todos, { ...item, isDone: false }]);
            setCompletedTodos(completedTodos.filter((todo) => todo.id !== id));

            return;
        }

        setTodos((todos) => todos.filter((todo) => todo.id !== id));
        setCompletedTodos((todos) => [...todos, { ...item, isDone: true }]);
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div className="App">
                <span className="heading">ToDo</span>
                <Input todo={todo} setTodo={setTodo} addTodos={addTodos} />
                <TodoList
                    toggleTodo={toggleTodo}
                    todos={todos}
                    setTodos={setTodos}
                    completedTodos={completedTodos}
                    setCompletedTodos={setCompletedTodos}
                />
            </div>
        </DragDropContext>
    );
};

export default App;
